module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Adress-book1-1417e41dafb05b7bca03146671c1862b.svg";